import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const ApiInterceptor: HttpInterceptorFn = (req, next) => {
  const isFormData = req.body instanceof FormData;

  if (!isFormData) {
    req = req.clone({
      headers: req.headers.set('Content-Type', 'application/json'),
    });
  }

  req = req.clone({
    headers: req.headers.set('Accept', 'application/json'),
  });

  const token = inject(SessionService).getToken();

  if (token) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(req);
};
